import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RunningList = lazy(() => import('./RunningList'));

const RunningListRoute: FuseRouteItemType = {
	path: '/running-list',
	element: <RunningList />
};

export default RunningListRoute;
